import useApi from "./useApi";

// Fetch customer with pagination
export default function useCustomer(page = 1, perPage = 20) {
  const { get } = useApi();
  const url = `admin/customers?page=${page}&per_page=${perPage}`;
  return get(url);
}

// Status Update
export function updateCustomerStatus(param) {
  //use api const
  const { put } = useApi();

  const {
    mutate: updateStatus,
  } = put(`admin/customers/`, {
    onSuccess: (data) => {
      if (
        data &&
        (data.success === true || data.status === "success")
      ) {
        param.toast.success("Status updated!");
      } else {
        param.toast.error(data.message || "Failed to update status");
      }
    },
    onError: (data) => {
      param.toast.error(data.message || "Failed to update status");
      
    },
    onSettled:(variables)=>{
      param.setStatusUpdating((prev) => ({ ...prev, [variables.id]: false }))
    }
  });
  return { updateStatus };
}
